import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M10.145 11.147c-.195.195-.195.512 0 .707s.512.195.707 0l2.001-2c.098-.098.147-.226.147-.354s-.049-.256-.147-.354l-2.001-2a.5003.5003 0 0 0-.707 0l.001.002a.5003.5003 0 0 0 0 .707l1.147 1.146H3.5c-1.93 0-3.5 1.57-3.5 3.5V17.5c0 .276.224.5.5.5s.5-.224.5-.5v-4.999c0-1.378 1.122-2.5 2.5-2.5h7.793l-1.148 1.146z',
    'M18.5 4.001H13c-.085 0-.238-.094-.276-.171l-.553-1.106C11.964 2.311 11.461 2 11 2H6c-.461 0-.965.311-1.171.724L4.276 3.83C4.119 4.145 4 4.649 4 5.001V7.5c0 .276.224.5.5.5s.5-.224.5-.5V5.001c0-.196.083-.549.17-.724l.553-1.107c.037-.073.194-.17.276-.17h5c.082 0 .24.098.277.171l.551 1.101c.205.415.709.728 1.173.728h5.5c.276 0 .5.224.5.5v8.999c0 .276-.224.5-.5.5h-13c-.276 0-.5-.224-.5-.5v-3c0-.276-.224-.5-.5-.5s-.5.224-.5.5v3c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5V5.5c0-.827-.673-1.5-1.5-1.5z',
  ],
  height: 20,
  width: 20,
});
